import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const getEffects = async () => {
  try {
    return await getData(`/website/effect/effect`);
  } catch (error) {
    console.log(error);
  }
};


export const EffectById = async (id) => {
  try {
    return await getData(`/website/effect/effect/${id}`);
  } catch (error) {
    console.log(error);
  }
};


// export const getProducts = async (effectId) => {
//   try {
//     return await getData(`/website/effect/product?effect_id=${effectId}`);
//   } catch (error) {
//     console.log(error);
//   }
// };


export const getProducts = async (effectId) => {
  let url = "/website/effect/product";

  if (effectId) {
    url += `?effect_id=${effectId}`;
  }

  return await getData(url);
};


export const ProductById = async (id) => {
  try {
    return await getData(`/website/effect/product/${id}`);
  } catch (error) {
    console.log(error);
  }
};
